var audio_rtlignore_default = {
  "fontElementMap": "_6JYXF",
  "container": "yw3gJ",
  "customPlayer": "GiAKX",
  "slim": "Lt6g5",
  "playPauseButton": "_1gGYZ",
  "coverImage": "LYjA9",
  "trackDetailsContainer": "rooes",
  "controlsContainer": "_7-Fge",
  "controlsGroup": "kO5aU",
  "sliderContainer": "qYEYk",
  "audioDuration": "_8Zgtg",
  "isLoading": "lQR8F",
  "audioDetails": "sOHVB",
  "authorName": "SuNIY",
  "title": "bGq-L",
  "dropdownMenuWrapper": "-JvGR",
  "dropdownSelectedButton": "_1C3vV",
  "dropdownContent": "JyUmO",
  "dropdownContentWithIcon": "X8M16",
  "audioLoader": "_2MMCg"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
